<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRastreabilidadeDashboardBungeSubEmpresa',
    componentOptions: {
        title: 'DashboardSubEmpresa',
        actions: [
            [
                {
                    name: 'Dashboard',
                    showView: false,
                    action: 'abrirDashboard',
                    route: 'DashboardRastreabilidadeSubEmpresa',
                    nameTranslationKey: 'mensagens.menuLateral.dashboard'
                }
            ]
        ]
    },

    methods: {
        abrirDashboard() {
            if (this.$route.name !== 'DashboardRastreabilidadeSubEmpresa') {
                this.$router.push({
                    name: 'DashboardRastreabilidadeSubEmpresa'
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
